export enum ItemTypes {
  HARDWARE = "hardware",
}

export interface ItemDetails {
  taxonomyId: string;
  parentTxId?: string;
  parentName?: string;
  name: string;
  description: string;
  shortDescription: string;
  status: string;
  logoUrl: string;
  publisher: string;
  etaDays: number;
  priceAmount: number;
  priceCurrency: string;
  os: string[];
  categories: string[];
  hasStock: boolean;
  version?: string;
  dataClassification?: string;
  securityStatus?: string;
}

export interface IItemVersion {
  taxonomyId: string;
  name: string;
  displayText: string;
  status: string;
  amount: number;
  currency: string;
  logoUrl?: string;
}
